import { FORM_LEN, STR_MAX, STR_MIN } from '@/constants';

export function getCustomerInitials(name: string): string {
  if (typeof name !== 'string' || name.length === STR_MIN) return '';

  const words = name.trim().split(/\s+/);

  if (words.length === FORM_LEN) {
    // Single name: take first two letters
    return words[STR_MIN].slice(STR_MIN, STR_MAX).toUpperCase();
  }

  // Multiple words: take first letter of first two words
  return words
    .slice(STR_MIN, STR_MAX)
    .map((word) => word[STR_MIN])
    .join('')
    .toUpperCase();
}
